import { Link } from "react-router-dom";

export default function HomeItems() {
    return (
        <div>
            <div>
                <Link to="listado">
                    Articulos/Stock
                </Link>
            </div>
            <div>
                <Link to="create">
                    Nuevo Articulo
                </Link>
            </div>
        </div>
    )
}